import React, { FunctionComponent } from "react";
import { Button, Input as AntdInput, Tooltip as AntdTooltip, Typography } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { currencyFormat } from "../helpers";
import "./styles.less";

interface InputWithPercentageProps {
	label: string;
	name?: string;
	value: string;
	percentage: number;
	handleChange: (value: string, name: string, type: string) => void;
	showIcon?: boolean;
}

const InputWithPercentage: FunctionComponent<InputWithPercentageProps> = ({
	label,
	value,
	name,
	percentage,
	handleChange,
	showIcon = false,
}) => {
	const handleValueInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = event.target.value.replace(/[^0-9.]/g, "");
		const type = event.target.name;
		handleChange(newValue, name, type);
	};

	const handleIncreaseValue = () => {
		const newValue = Number(value) + 500_000;
		handleChange(newValue.toString(), name, "price");
	};

	const handleDecreaseValue = () => {
		const newValue = Number(value) - 500_000;
		handleChange(newValue.toString(), name, "price");
	};

	return (
		<div style={{ padding: "8px 0" }}>
			<div className="label">
				<Typography.Paragraph style={{ color: "#082645" }}>{label}</Typography.Paragraph>
				{showIcon && (
					<AntdTooltip
						style={{ marginLeft: "4px" }}
						title="Es el dinero que tienes disponible para la compra de tu vivienda pueden ser ahorros, cdt's, ventas de vehículos u otros.">
						<QuestionCircleOutlined style={{ cursor: "pointer", marginLeft: "4px", color: "#082645"}} />
					</AntdTooltip>
				)}
			</div>

			<div className="buttonGroup">
				<Button
					onClick={handleDecreaseValue}
					className="upDownButton"
					style={{ borderRadius: "6px 0 0 6px" }}
					icon={<ArrowDownOutlined style={{ color: "#28A745" }} />}
				/>
				<AntdInput
					className="input"
					name="price"
					value={`$ ${currencyFormat(value)}`}
					onChange={handleValueInputChange}
				/>
				<Button
					onClick={handleIncreaseValue}
					className="upDownButton"
					style={{
						marginRight: 12,
						borderRadius: "0 6px 6px 0",
						borderRightColor: "#c2ccda",
						borderLeftColor: "#c2ccda",
					}}
					icon={<ArrowUpOutlined style={{ color: "#28A745" }} />}
				/>
				<AntdInput
					className="inputPercentage"
					onChange={handleValueInputChange}
					value={`${percentage.toFixed()}%`}
					name="percentage"
				/>
			</div>
		</div>
	);
};

export default InputWithPercentage;

